import { z } from "zod";

export const platformHealthSchema = z.object({
  service: z.literal("platform-api"),
  status: z.literal("ok"),
});

export type PlatformHealth = z.infer<typeof platformHealthSchema>;
